import React, { useState } from 'react'
import { CheckCircle } from '../../svg/Icons'
import { HiEye, HiInformationCircle } from "react-icons/hi";
import { Alert } from 'flowbite-react';

type Step = 
    "alert_generated_master_key" | 
    "alert_registered_master_key" |
    "alert_requested_IDT" 

interface StepAlertProps {
    step: Step
}

const AleartData = (step: Step) => {
    var title, desc = ""
    switch (step) {
        case "alert_generated_master_key":
            title = "Your MPK Has Been Successfully Generated!";
            desc = "Congratulations! Your MPK is now ready. The next step is to register it with an OIDC Authorization Server, enabling secure IDT++ issuance.";
          break;

        case "alert_registered_master_key":
            title = "Your MPK Has Been Successfully Registered!";
            desc = "Your MPK is now securely registered with the Authorization Server. You can begin requesting IDT++ tokens.";
          break;

        case "alert_requested_IDT":
            title = "Your IDT++ Has Been Successfully Issued!";
            desc = "Your IDT++ token is ready. Import it into your wallet and use it like any other digital credential, such as a PDF.";
          break;

        }
    return {title, desc}
}

const Alerts = (props:StepAlertProps) => {

    const data = AleartData(props.step)

    const [dismissed, setIsDismissed] = useState(false);

    return (<>

        {!dismissed && 
            <div id="alert-border-1" className="flex flex-col p-4 mb-4 mt-4 text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400 gap-1.5" role="alert">
                <div className='flex justify-between'>

                    <div className="flex items-center gap-2">
                        <CheckCircle className="size-[18px] shrink-0"/>
                        <span className="sr-only">{data.title}</span>
                        <h3 className="text-base font-semibold leading-6">{data.title}</h3>
                    </div>

                    <div>
                        <button type="button" className="ms-auto -mx-1.5 -my-1.5 bg-green-50 text-green-500 rounded-lg focus:ring-2 focus:ring-green-400 p-1.5 hover:bg-green-200 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:text-green-400 dark:hover:bg-gray-700" onClick={() => {setIsDismissed(true)}} data-dismiss-target="#alert-border-1" aria-label="Close">
                            <span className="sr-only">Close</span>
                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                        </button>
                    </div>
                </div>
                
                <div className=" text-sm font-normal leading-5">
                    {data.desc}
                </div>
                
            </div>
       }

    </>)
}

export default Alerts
